var _path, _line, _path2, _path3, _path4, _line2, _line3, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3748 41.5478C37.3748 37.2831 43.7353 36.4302 43.7353 27.9008C43.7353 20.8348 38.0203 15.1067 30.9706 15.1067C23.9209 15.1067 18.2059 20.8348 18.2059 27.9008C18.2059 36.4302 24.5664 37.2831 24.5664 41.5478",
    stroke: "#A7B0BE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25.275,
    y1: 47.6058,
    x2: 36.1166,
    y2: 44.5082,
    stroke: "#A7B0BE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 51.5769L36.2258 48.2153",
    stroke: "#A7B0BE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3528 51.5771C35.9049 53.8136 33.7864 55.2242 31.4263 55.2242C29.0662 55.2242 26.9478 53.8136 25.4999 51.5771",
    stroke: "#A7B0BE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6469 21.1071C35.383 21.1071 38.4116 24.1358 38.4116 27.8718",
    stroke: "#C4CAD4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 3.55882,
    y2: -1,
    transform: "matrix(-1 0 0 1 14.5587 26.9597)",
    stroke: "#C4CAD4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 31.9999,
    y1: 10.0188,
    x2: 31.9999,
    y2: 6.60704,
    stroke: "#C4CAD4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 4.15771,
    y2: -1,
    transform: "matrix(-0.707107 -0.707106 -0.707107 0.707106 19.1176 16.0188)",
    stroke: "#C4CAD4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 11,
    x2: 50,
    y2: 19,
    stroke: "#431885",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 15,
    x2: 54,
    y2: 15,
    stroke: "#431885",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationIdea);
export default __webpack_public_path__ + "static/media/illustration-idea.9b941c6ec8f25c9bf324f3f4a28f9b4c.svg";
export { ForwardRef as ReactComponent };